module.exports = __webpack_public_path__ + "1.4.15-unryo/img/online-portal-4.bc8903e7.svg";